import HttpRequest from './http_request'

class payInSlipProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT+'/')
  }

//-------------------------------------------------------------สำหรับสมัคร 
//ข้อมูลการสมัคร
async getPaymentApplicationFee(REGISTER_ID) {
    const { data } = await this.get('admission/api/', {
      function: 'get-payment-application-fee',
      REGISTER_ID: REGISTER_ID, 
    })
    return data
  }

  async getPaymentAssertionFee(REGISTER_ID) {
    const { data } = await this.get('admission/api/', {
      function: 'get-payment-confirm-fee',
      REGISTER_ID: REGISTER_ID, 
    })
    return data
  }

  async getServertime() {
    const { data } = await this.get('api/', {
      function: 'get-server-time',
    })
    return data
  }



async saveAssertionFee({REGISTER_ID,PAYMENT_CONFIRM_FEE}) {
  const { data } = await this.update('admission/api/', {
    function: 'set-assertion-fee',
    REGISTER_ID:REGISTER_ID,
    PAYMENT_CONFIRM_FEE:PAYMENT_CONFIRM_FEE,
  })
  return data
}

async saveCurriculumAndApplicantStatus({REGISTER_ID,REGISTER_STATUS_ID,REFUSED,register_curriculum}) {
  const { data } = await this.update('admission/api/', {
    function: 'set-curriculum-and-applicant-status',
    REGISTER_ID:REGISTER_ID,
    REGISTER_STATUS_ID:REGISTER_STATUS_ID,
    REFUSED:REFUSED,
    register_curriculum:register_curriculum,
  })
  return data
}

}

export default payInSlipProvider